exports = module.exports = require("../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auction-detail-name {\n    width: 200px;\n    margin-bottom: 5px;\n    color: gray;\n    font-weight: 200;\n    float: left;\n}\n\n.auction-detail-conatiner {\n    width: 100%;\n    overflow: hidden;\n}", ""]);

// exports
